<template>
	<div class="layout">
		<div class="tool-box">
			<div class="tool-box-title">
				<img src="/static/imgs/danju.png" class="jxyd-imgicon" />
				操作成本调整单
			</div>
			<button class="jxyd-button jxyd-primary" title="审核" @click="dataSubmitAndCheck"
				v-show="permission.isAudit && documentItem.checkState == 1">
				<Icon type="md-checkmark-circle-outline" size="20" />
				审核
			</button>
			<button class="jxyd-button" title="回滚" @click="rollback([documentItem.id])"
				v-show="permission.isRollback && documentItem.id > 0 && documentItem.checkState > 1">
				<Icon type="md-sync" size='18' />
				回滚
			</button>
			<button class="jxyd-button" title="保存" @click="dataSubmit"
				v-show="permission.isEdit && documentItem.checkState == 1">
				<Icon type="md-bookmark" size='18' />
				保存
			</button>
			<button class="jxyd-button" title="打印" @click="printList" v-show="permission.isPrint">
				<Icon type="md-print" size='18' />
				打印
			</button>
		</div>
		<div>
			<div class="baseInfo">
				<div class="modal-title">
					<div class="layout-title-left">
						<img src="/static/imgs/jibenxinxi.png" class="jxyd-imgicon" />
						基本信息
					</div>
					<div class="layout-title-right">
					</div>
				</div>

				<table class="baseinfo-table">
					<tr>
						<td class="key">
							单据编号
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="width:35%;">
							<input readonly="readonly" v-model="documentItem.code" type="text" placeholder="请输入单据编号"
								class="baseinfo-input" />
						</td>
						<td class="key">
							业务日期
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="width:35%;">
							<input v-model="documentItem.businessDate" type="date" placeholder="请选择业务日期"
								class="baseinfo-input" />
						</td>
					</tr>

					<tr>
						<td class="key">
							业务员
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td class="selectBox">
							<Select v-model="documentItem.userId" filterable clearable>
								<Option v-for="item in userList" placeholder="请选择业务员" :value="item.id" :key="item.id">
									{{item.userDisplayName}}
								</Option>
							</Select>
						</td>
						<td class="key">
							备注
						</td>
						<td style="text-align: left;">
							<input type="textarea" v-model="documentItem.note" placeholder="请输入备注"
								class="baseinfo-input">
						</td>
					</tr>
				</table>
			</div>
			<div class="commodityInfo">
				<div class="modal-title">
					<div class="layout-title-left">
						<img src="/static/imgs/shangpin.png" class="jxyd-imgicon" />
						商品信息
					</div>
					<div class="layout-title-right">
						<SelectCommodityModal ref="selectCommodityModal" @getResult="initCommodityList"
							:selectedCommodity="commodityIds" :isStock="false"></SelectCommodityModal>
						<Input type="text" v-model="scanCodeId" placeholder="使用扫码枪或手动输入"
							@keydown.enter.native="enterDownTime = new Date().getTime()"
							@keyup.enter.native="scanUpFunc" icon="md-qr-scanner" style="width:200px;" />
					</div>
				</div>
				<Table stripe :columns="commodityColumn" :data="documentItem.commodityCostAdjustDetailList"></Table>
			</div>
			<div class="file">
				<div class="modal-title" style="border-bottom: 1px solid #e8eaec;">
					<div class="layout-title-left">
						<Icon type="ios-link" size='20' color='#bd10e0' />
						单据附件
					</div>
					<div class="layout-title-right">
					</div>
				</div>
				<div style="padding:15px 10px;">
					<DocumentFile :isShow='false' :fileList.sync='documentItem.fileList'
						:actionPath='"/file/file/UploadFile"'></DocumentFile>
				</div>
			</div>
			<div class="billStateCls" v-show="documentItem.checkState == 2"><span>已审核</span></div>
			<div class="billStateCls" v-show="documentItem.checkState == 3"><span>已完结</span></div>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import formatNum from '@/utils/formatNum'
	import SelectCommodityModal from '@/components/SelectCommodityModal'
	import SelectCommodityPackageModal from '@/components/SelectCommodityPackageModal'
	import formatDate from '@/utils/formatDate'
	import dateUtil from '@/utils/dateUtil'
	import DocumentFile from '@/components/DocumentFile'
	export default {
		name: 'commoditycostadjustlistfunc',
		components: {
			SelectCommodityModal,
			DocumentFile
		},
		data() {
			return {
				documentItem: {
					id: 0,
					code: '',
					businessDate: '',
					commodityCostAdjustDetailList: [],
					userId: '',
					userName: '',
					creator: parseInt(localStorage.getItem("userId")),
					note: '',
					checkState: 1, //未审核
					fileList: []
				},
				commodityColumn: [{
						title: '操作',
						key: 'action',
						width: 80,
						align: 'center',
						fixed: 'left',
						render: (h, params) => {
							return [h('Icon', {
								style: {
									cursor: 'pointer'
								},
								props: {
									type: 'md-trash',
									size: 24
								},
								on: {
									click: (e) => {
										this.documentItem.commodityCostAdjustDetailList.splice(
											params.index, 1);
										this.commodityIds.splice(params.index, 1);
									}
								}
							})]
						}
					},
					{
						title: '商品',
						key: 'commodityName',
						fixed: 'left',
						width: 345,
						render: (h, params) => {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										this.$router.push({
											path: 'commoditydetailinfo',
											query: {
												commodityId: params.row.commodity.id
											}
										});
									}
								}
							}, params.row.commodityName);
						}
					},
					{
						title: '规格',
						key: 'commodityFormat',
						width: 200,
					},
					{
						title: '调前采购价',
						key: 'lastIntoPrice',
						width: 200,
					},
					{
						title: '调前销售价',
						key: 'lastOutPrice',
						width: 200,
					},
					{
						title: '调后采购价',
						key: 'currentIntoPrice',
						width: 200,
						render: (h, params) => {
							return [h('Input', {
								props: {
									transfer: true,
									value: params.row.currentIntoPrice
								},
								on: {
									input: (event) => {
										this.documentItem.commodityCostAdjustDetailList[params
											.index].currentIntoPrice = event;
									}
								},
							})];
						}
					},
					{
						title: '调后销售价',
						key: 'currentOutPrice',
						width: 200,
						render: (h, params) => {
							return [h('Input', {
								props: {
									transfer: true,
									value: params.row.currentOutPrice
								},
								on: {
									input: (event) => {
										this.documentItem.commodityCostAdjustDetailList[params
											.index].currentOutPrice = event;
									}
								},
							})];
						}
					},
					{
						title: '备注',
						key: 'note',
						width: 400,
						render: (h, params) => {
							return [h('Input', {
								props: {
									min: 0,
									value: params.row.note
								},
								style: {
									'width': '100%'
								},
								on: {
									input: (e) => {
										this.documentItem.commodityCostAdjustDetailList[params
											.index].note = e;
									}
								}
							})]
						}
					}
				],
				commodityIds: [],
				userList: [],
				permission: {
					isAdd: false,
					isEdit: false,
					isDelete: false,
					isAudit: false,
					isBatchAudit: false,
					isPrint: false,
					isRollback: false,
					isExport: false,
					isBatchPrint: false
				},
				scanCodeId: '',
				enterDownTime: '',
				enterUpTime: ''
			}
		},

		methods: {
			emptyForm() {
				this.documentItem.id = 0;
				this.documentItem.businessDate = formatDate(dateUtil.getCurrentDate(), 'yyyy-MM-dd');
				this.documentItem.commodityCostAdjustDetailList = [];
				this.commodityIds = [];
				this.documentItem.userId = parseInt(localStorage.getItem("userId"));
				this.documentItem.creator = parseInt(localStorage.getItem("userId"));
				this.documentItem.note = '';
				this.documentItem.checkState = 1; //未审核
				this.documentItem.fileList = [];
				this.getNextCode();
			},
			submitValidate() {
				if (!this.documentItem.code) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "编号不可为空"
					});
					return false;
				}
				if (!this.documentItem.businessDate) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择业务日期"
					});
					return false;
				} else {}
				if (!this.documentItem.userId) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择业务员"
					});
					return false;
				}
				if (this.documentItem.commodityCostAdjustDetailList.length <= 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "您还没有选择商品"
					});
					return false;
				}
				return true;
			},
			dataSubmit() {
				var validate = this.submitValidate();
				if (!validate) {
					return;
				}
				let self = this;
				request.post('/api/CommodityCostAdjustList/EditCommodityCostAdjustList', self.documentItem).then(function(
					response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}
					//记录成本调整单操作
					var log = {
						FlowId: response.data,
						Title: '成本调整单日志',
						OperationContent: self.documentItem.id > 0 ? '编辑了此成本调整单' : '创建了此成本调整单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}
					request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.data.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败:' + response.data.errorMsg
							});
							return;
						}
					}).catch(function(error) {})
					//清空form规则检查
					self.emptyForm();
					self.$Notice.success({
						title: '正确提示',
						duration: 3,
						desc: '保存成功!'
					});
				}).catch(function(error) {})
			},
			dataSubmitAndCheck() {
				var validate = this.submitValidate();
				if (!validate) {
					return;
				}
				let self = this;
				request.post('/api/CommodityCostAdjustList/EditCommodityCostAdjustList', self.documentItem).then(function(
					response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}

					//记录成本调整单操作
					var log = {
						FlowId: response.data,
						Title: '成本调整单日志',
						OperationContent: self.documentItem.id > 0 ? '编辑了此成本调整单' : '创建了此成本调整单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}
					request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.data.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败:' + response.data.errorMsg
							});
							return;
						}
					}).catch(function(error) {})

					self.documentItem.id = response.data;
					self.checkCommodityCostAdjustList([self.documentItem], 2, '成本调整单审核后不可更改，内容不可编辑，是否继续操作？');
				}).catch(function(error) {})
			},
			getNextCode() {
				let self = this;
				request.get('/api/CommodityCostAdjustList/GetNextCode', {
					params: {
						prefix: 'CBTZ'
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}

					self.documentItem.code = response.data;
				}).catch(function(error) {})
			},
			rollback(ids) {
				if (ids.length < 1) {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "没有选中记录！"
					});
					return;
				}
				let self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: '是否回滚到审核流程？',
					onOk() {
						request.post('/api/CommodityCostAdjustList/Rollback', ids).then(function(response) {
							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: "成本调整单回滚失败：" + response.errorMsg
								});
								return;
							}

							var log = [];
							for (var i = 0; i < ids.length; i++) {
								//记录采购单操作
								log.push({
									FlowId: ids[i],
									Title: '成本调整单日志',
									OperationContent: '回滚了此成本调整单',
									Operator: parseInt(localStorage.getItem("userId")),
									State: 1,
									Creator: parseInt(localStorage.getItem("userId"))
								});
							}
							request.post('/api/ProcessLog/AddProcessLog', log).then(function(response) {
								if (response.data.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '日志记录失败:' + response.data.errorMsg
									});
									return;
								}
							}).catch(function(error) {})
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '回滚成功!'
							});
							self.getCostAdjustList(ids[0]);
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			checkCommodityCostAdjustList(objs, state, func) {
				var self = this;
				if (objs.length <= 0) {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "没有选中记录！"
					});
					return;
				}

				let stateObj = [];
				let commodityCostAdjustIds = [];
				for (var i = 0; i < objs.length; i++) {
					if (state == 2) {
						if (objs[i].checkState != 1) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "选中记录中包含不可审核的数据！"
							});
							return;
						}

						stateObj.push({
							id: objs[i].id,
							state: 2
						});
						commodityCostAdjustIds.push(objs[i].id);
					}
				}

				this.$Modal.confirm({
					title: "操作警告",
					content: func,
					onOk() {
						request.post('/api/CommodityCostAdjustList/CheckCommodityCostAdjustList', stateObj).then(
							function(response) {

								if (response.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: response.errorMsg
									});
									return;
								}
								let tag = '';
								if (state == 1) {

								} else if (state == 2) {
									tag = '审核';
								}

								var log = [];
								for (var i = 0; i < commodityCostAdjustIds.length; i++) {
									//记录采购单操作
									log.push({
										FlowId: commodityCostAdjustIds[i],
										Title: '成本调整单日志',
										OperationContent: tag + '了此成本调整单',
										Operator: parseInt(localStorage.getItem("userId")),
										State: 1,
										Creator: parseInt(localStorage.getItem("userId"))
									});
								}

								request.post('/api/ProcessLog/AddProcessLog', log).then(function(response) {
									if (response.data.state == 0) {
										self.$Notice.error({
											title: '错误提示',
											duration: 3,
											desc: '日志记录失败:' + response.data.errorMsg
										});
										return;
									}
								}).catch(function(error) {})
								self.$Notice.success({
									title: '正确提示',
									duration: 3,
									desc: tag + '成功!'
								});
								self.emptyForm();
							}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			scanUpFunc() {
				this.enterUpTime = new Date().getTime();
				if (this.enterUpTime - this.enterDownTime < 30) {
					this.addCommodityByCode(this.scanCodeId);
				} else {
					this.$refs.selectCommodityModal.searchItems.searchVal = this.scanCodeId;
					this.$refs.selectCommodityModal.openSelectCommodityModal();
					this.scanCodeId = '';
				}
			},
			addCommodityByCode(code) {
				this.scanCodeId = '';
				for (var i = 0; i < this.modelData.commodityCostAdjustDetailList.length; i++) {
					if (this.modelData.commodityCostAdjustDetailList[i].commodity.code == code) {
						return;
					}
				}
				let self = this;
				request.get('/api/Commodity/GetCommodityByCode', {
					params: {
						code: code
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "扫条码获取商品失败：" + response.errorMsg
						});
						return;
					}
					self.initCommodityList([response.data]);
				}).catch(function(error) {})
			},
			initCommodityList(data) { //初始化商品列表数据源
				let isExist = false;
				for (var i = 0; i < data.length; i++) {
					isExist = false;
					for (var n = 0; n < this.commodityIds.length; n++) {
						if (data[i].id == this.commodityIds[n]) {
							isExist = true;
							break;
						}
					}
					if (!isExist) {
						//插入商品Id集合
						this.commodityIds.push(data[i]);
						//插入商品集合
						this.documentItem.commodityCostAdjustDetailList.push({
							commodityId: data[i].id,
							commodityName: data[i].name,
							commodityFormat: data[i].format,
							lastIntoPrice: data[i].intoPrice,
							lastOutPrice: data[i].outPrice,
							currentIntoPrice: 0,
							currentOutPrice: 0,
							note: data[i].note,
							creator: parseInt(localStorage.getItem("userId")),
							commodity: data[i]
						});
					}
				}
			},
			initUserToSelect() { //初始化用户下拉框数据源
				let self = this;
				request.get('/api/User/GetUserToSelect').then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}
					self.userList = response.data;
				}).catch(function(error) {})
			},
			initPermission() {
				let self = this;
				let params = {
					funcCodes: ['CommodityCostAdjustList.Add', 'CommodityCostAdjustList.Edit',
						'CommodityCostAdjustList.Delete',
						'CommodityCostAdjustList.Audit', 'CommodityCostAdjustList.BatchAudit',
						'CommodityCostAdjustList.Print',
						'CommodityCostAdjustList.Rollback', 'CommodityCostAdjustList.Export',
						'CommodityCostAdjustList.BatchPrint'
					],
					userId: parseInt(localStorage.getItem("userId"))
				};
				request.post('/api/Function/VerifyPermissions', params).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取权限数据失败：" + response.errorMsg
						});
						return;
					}
					for (var i = 0; i < response.data.length; i++) {
						switch (response.data[i].funcCode) {
							case 'CommodityCostAdjustList.Add':
								self.permission.isAdd = response.data[i].permission
								break;
							case 'CommodityCostAdjustList.Edit':
								self.permission.isEdit = response.data[i].permission
								break;
							case 'CommodityCostAdjustList.Delete':
								self.permission.isDelete = response.data[i].permission
								break;
							case 'CommodityCostAdjustList.Audit':
								self.permission.isAudit = response.data[i].permission
								break;
							case 'CommodityCostAdjustList.BatchAudit':
								self.permission.isBatchAudit = response.data[i].permission
								break;
							case 'CommodityCostAdjustList.Print':
								self.permission.isPrint = response.data[i].permission
								break;
							case 'CommodityCostAdjustList.Rollback':
								self.permission.isRollback = response.data[i].permission
								break;
							case 'CommodityCostAdjustList.Export':
								self.permission.isExport = response.data[i].permission
								break;
							case 'CommodityCostAdjustList.BatchPrint':
								self.permission.isBatchPrint = response.data[i].permission
								break;
						}
					}
				}).catch(function(error) {})
			},
			packPrintData(data) {
				data.forEach((item,index)=>{
					switch(item.checkState){
						case 1:
							item.checkState = '已创建'
						break;
						case 2:
							item.checkState = '已审核'
						break;
						case 3:
							item.checkState = '已完结'
						break;
					}
				})
				let selectedReceiptData = {
					name: 'commodityCostAdjustList',
					title: '成本调整单',
					attributes: ['baseFieldItem', 'commodityCostAdjustDetailList'],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'checkState',
							displayName: '单据状态'
						},
						{
							name: 'createDate',
							displayName: '创建时间'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					],
					commodityCostAdjustDetailList: [{
							name: 'commodityName',
							displayName: '商品名'
						},
						{
							name: 'commodityFormat',
							displayName: '商品规格'
						},
						{
							name: 'lastIntoPrice',
							displayName: '调前采购价格'
						},
						{
							name: 'lastOutPrice',
							displayName: '调前销售价格'
						},
						{
							name: 'currentIntoPrice',
							displayName: '调后采购价格'
						},
						{
							name: 'currentOutPrice',
							displayName: '调后销售价格'
						},
						{
							name: 'note',
							displayName: '备注'
						},
						{
							name: 'createDate',
							displayName: '创建时间'
						}
					]
				}
				localStorage.setItem('_printData', JSON.stringify(selectedReceiptData));
				this.$router.push({
					path: 'printerpage'
				});
			},
			printList() {
				this.packPrintData([this.documentItem]);
			},
			getCostAdjustList(costAdjustListId) {
				let self = this;
				request.get('/api/CommodityCostAdjustList/GetCommodityCostAdjustList', {
					params: {
						id: costAdjustListId
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.initCostAdjustList(response.data);
				}).catch(function(error) {})
			},
			initCostAdjustList(data) {
				this.documentItem = data;
				this.commodityIds = [];
				for (var i = 0; i < data.commodityCostAdjustDetailList.length; i++) {
					this.commodityIds.push(data.commodityCostAdjustDetailList[i].commodity);
				}
			}
		},
		watch: {
			'$route.query.costAdjustListId': {
				immediate: true,
				handler(param) {
					if (param) {
						this.getCostAdjustList(param);
					} else {
						this.emptyForm();
					}
				}
			}
		},
		created: function() {
			this.emptyForm();
			this.initPermission();
			this.initUserToSelect();
		}
	}
</script>

<style scoped>
	.layout {
		border-radius: 8px;
	}

	.tool-box {
		padding: 10px;
		background-color: #fff;
		overflow: hidden;
		border-left: 5px solid rgb(255, 106, 127);
		margin-bottom: 10px;
	}

	.tool-box Button {
		margin-left: 10px;
		float: right;
	}

	.tool-box-title {
		float: left;
		font-size: 16px;
		color: black;
		height: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.baseInfo {
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.baseinfo-table {
		width: 100%;
		background-color: #fff;
		color: #666;
		border-collapse: collapse;
	}

	.baseinfo-table td,
	.baseinfo-table th {
		position: relative;
		padding: 9px 15px;
		min-height: 20px;
		line-height: 20px;
		font-size: 14px;
		border-width: 1px;
		border-style: solid;
		border-color: #e6e6e6;
	}


	.baseinfo-input {
		border: none;
		outline: none;
		height: 15px;
		padding-left: 0px;
		width: 100%;
	}

	.commodityInfo {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.file {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.modal-title {
		overflow: hidden;
		padding-bottom: 10px;
		font-size: 16px;
	}

	.layout-title-left {
		float: left;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.layout-title-right {
		float: right;
	}

	.selectBox /deep/ div {
		border: none !important;
	}

	.discount-label {
		display: inline-block;
		text-align: center;
		width: 29%;
	}

	.billStateCls {
		width: 100px;
		height: 50px;
		line-height: 50px;
		font-size: 16px;
		position: absolute;
		top: 100px;
		left: 200px;
		border: solid 2px red;
		color: red;
		font-weight: 600;
		-webkit-transform: rotate(-30deg);
		transform: rotate(-30deg);
		z-index: 19999;
	}
</style>